import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { homeWarningText } from '@cerebro-diem/core';
import { errorMessage } from '../../services/errors';
import { useHomeWarnings } from '../../services/health';

/**
 * Today's warnings, above everything else: reminders are coming and no device
 * will receive them (CER-80), and, for an owner, something is wrong now
 * (CER-69). Each links to Settings. Nothing when there is nothing to say; a
 * check that failed says so.
 */
export default function HomeWarnings() {
  const query = useHomeWarnings();
  if (query.isPending) return null;
  if (query.isError) {
    return <p className="text-sm text-error">Could not check whether your reminders reach a device: {errorMessage(query.error)}</p>;
  }
  const { noDevice, problems } = homeWarningText(query.data);
  // Each goes straight to the part of Settings that says what is wrong, opened.
  const lines = [
    noDevice && { line: noDevice, to: '/settings#notifications', label: 'Notifications' },
    problems && { line: problems, to: '/settings#system-status', label: 'System status' },
  ].filter((entry): entry is { line: string; to: string; label: string } => Boolean(entry));
  if (lines.length === 0) return null;
  return (
    <div className="space-y-2">
      {lines.map(({ line, to, label }) => (
        <div key={line} role="alert" className="flex flex-wrap items-center gap-3 rounded-xl border border-error/30 bg-error/10 p-4 text-sm">
          <AlertCircle className="w-5 h-5 shrink-0 text-error" />
          {/* A width of its own to start from, so the link beside it never squeezes it to a sliver on a phone. */}
          <p className="min-w-0 flex-1 basis-64">{line}</p>
          <Link to={to} className="font-medium underline">
            {label}
          </Link>
        </div>
      ))}
    </div>
  );
}
